import { RootState } from "../../../redux-store";

export const selectCargoTypes = (state: RootState) => state.app.cargoTypes.cargoTypes;